
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const useAuthNavigation = () => {
  const navigate = useNavigate();

  const handleAuthNavigation = (loginType: string, userType?: string) => {
    console.log("Handling navigation for:", { loginType, userType });
    
    if (loginType === "owner") {
      navigate("/owner");
    } else if (loginType === "admin" && userType === "admin") {
      navigate("/admin");
    } else {
      toast.error("Type d'utilisateur non reconnu");
    }
  };

  return { handleAuthNavigation };
};
